/** Detect Veto Buyer Funding opened inside the iOS App Clip (native shell adds ?veto_app_clip=1). */

export const APP_CLIP_QUERY_PARAM = "veto_app_clip";

export function isAppClipContext(): boolean {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  if (params.get(APP_CLIP_QUERY_PARAM) === "1") return true;
  try {
    return window.navigator.userAgent.includes("VetoBuyerFundingAppClip");
  } catch {
    return false;
  }
}

export function withAppClipQuery(url: string): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set(APP_CLIP_QUERY_PARAM, "1");
    return parsed.toString();
  } catch {
    return url;
  }
}

export function appClipBannerCopy(): string {
  return "Opened in the Veto App Clip — no App Store install. Same secure flow as Safari.";
}
